import { ColumnsType } from 'antd/es/table';
import { Edit2 } from 'iconsax-react';
import SectionDesc from '../../../components/atoms/SectionDesc';
import CustomTable from '../../../components/atoms/CustomTable';
import { useTranslation } from 'react-i18next';

import { PromotionSlot } from '../../../types/promotionSlots';

interface SlotsSectionProps {
  title: string;
  data: PromotionSlot[];
  isLoading?: boolean;
  onEdit: (item: PromotionSlot) => void;
}

export default function SlotsSection({
  title,
  data,
  isLoading,
  onEdit,
}: SlotsSectionProps) {
  const { t } = useTranslation();

  const columns: ColumnsType<PromotionSlot> = [
    {
      title: t('home.slots-type'),
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: t('home.slots-number-of-slots'),
      dataIndex: 'numberOfSlots',
      key: 'numberOfSlots',
      render: (val: number, record) => `${val} ${record.unit}`,
    },
    {
      title: t('home.action'),
      key: 'action',
      render: (_, record) => (
        <div
          className="w-8 h-8 rounded-md bg-blue-50 flex items-center justify-center cursor-pointer transition-colors hover:bg-blue-100"
          onClick={() => onEdit(record)}
        >
          <Edit2 size={16} className="text-blue-500" variant="Bold" />
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-xl p-6 flex flex-col gap-6 shadow-sm border border-gray-100">
      <div className="flex flex-col gap-1">
        <h3 className="text-[#111928] text-2xl font-bold leading-none">
          {title}
        </h3>
        <SectionDesc text={t('home.slots-page-desc')} />
      </div>
      <CustomTable
        loading={isLoading}
        columns={columns}
        dataSource={data}
        rowKey="id"
        currentPage={0}
        totalElements={data.length}
        onPageChange={() => {}}
        onRowClick={() => {}}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}
